/**
 * isMapMode checks whether the search is for the map
 * @returns Boolean
 */
function isMapMode(): boolean {
    return document.documentElement.classList.contains( 'mapsearch' );
}

function getAllowedCurrentLocationCountries(): Array<string> {
    if ( process.env.CURRENT_LOCATION_COUNTRIES ) {
        return process.env.CURRENT_LOCATION_COUNTRIES.split( ',' ).map( ( c ) => c.toUpperCase() );
    }
    return [ 'ES' ];
}

export {
    isMapMode,
    getAllowedCurrentLocationCountries,
};
